import { useState } from "react";
import { useMutation, useQuery } from "react-query";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
//primereact
import { Button } from "primereact/button";
import { BreadCrumb } from "primereact/breadcrumb";
//components
import Panel from "../../../components/panel/panel";
import Input from "../../../components/input/Input";
//services
import { TableData } from "./TableData";
import { queryClient } from "../../../utils/queryClient";
import { getPaymentMethods } from "../../../services/Settings/PaymentMethods/getPaymentMethods";
import { postPaymentMethods } from "../../../services/Settings/PaymentMethods/postPaymentMethods";
import { Link } from "react-router-dom";
import NumberInput from "../../../components/input/NumberInput";
import usePermission from "../../../hooks/usePermission";
import { useAppContext } from "../../../context/AppContext";

const PaymentMethods = ({ financing = null, setVisible }) => {
  usePermission("156"); // Visualiza Formas de Pagamento
  const { permissions } = useAppContext()
  const form = useForm();
  const errors = form.formState.errors;

  const [loading, setLoading] = useState(false);

  const items = [
    {
      template: () => (
        <Link to={`/settings/paymentMethods`} className="p-breadcrumb-link">
          Método de pagamento
        </Link>
      ),
    },
  ];

  const home = {
    template: () => (
      <Link to={"#"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  const { data, refetch } = useQuery({
    queryKey: ["payment-methods"],
    queryFn: () => getPaymentMethods(),
    enabled: !!permissions?.includes("156")
  });

  const { mutateAsync: postPaymentMethodsFn } = useMutation({
    mutationFn: postPaymentMethods,
    onSuccess(paymentsMethods) {
      queryClient.setQueryData(["payment-methods"], (data) => {
        return [...data, paymentsMethods.data];
      });
    },
    onError(error) {
      //      console.log(error);
    },
  });

  const onSubmit = async (data) => {
    setLoading(true);
    const notification = toast.loading("Adicionando..");
    try {
      const response = await postPaymentMethodsFn(data);

      form.reset();
      toast.update(notification, {
        render: "Forma de pagamendo cadastrada com Sucesso!",
        type: "success",
        theme: "colored",
        autoClose: 3000,
        isLoading: false,
      });

    } catch (error) {
      const errorMessage = error.response
        ? error.response.data.errors.name
        : "Erro desconhecido ao cadastrar forma de pagamento.";
      toast.update(notification, {
        render: `Não Possível Cadastrar Forma de Pagamento! Erro: ${errorMessage}`,
        type: "error",
        theme: "colored",
        autoClose: 3000,
        isLoading: false,
      });
    } finally {
      if (setVisible) {
        setVisible(false)
      }
      refetch();
      setLoading(false);
    }
  };

  return (
    <>
      {!financing && (
        <div className="col-xl-4">
          <BreadCrumb
            model={items}
            home={home}
            style={{
              background: "transparent",
              border: "none",
              fontSize: "16px",
            }}
          />
        </div>
      )}
      {permissions && permissions.includes("157") && ( //Cadastrar Formas de Pagamento
        <Panel mainCss="mb-4" title="Novo método de pagamento">
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <div className="row">
              <div className="col-xl-6 col-md-6 my-2 form-group">
                <Input
                  className="w-100"
                  control={form.control}
                  isRequired={true}
                  errors={errors}
                  name="name"
                  label="Método de pagamento"
                />
              </div>
              <div className="col-xl-3 col-md-6 d-flex m-auto my-4 form-group">
                <div className="text-center">
                  <Button
                    label="Adicionar"
                    icon="fa fa-plus"
                    aria-label="Search"
                    className={`rounded-3 py-2.5 w-100`}
                    loading={loading}
                  />
                </div>
              </div>
            </div>
          </form>
        </Panel>
      )}
      {!financing && (
        <TableData dataTable={data} loading={loading} setLoading={setLoading} />
      )}
    </>
  );
};

export default PaymentMethods;
